import React from 'react'
import { DoseMeSpinner } from '@doseme/cohesive-ui'

import { Modal } from '../Modal/Modal'

interface IProps {
  error?: string
  onHide?: () => void
}

const loadingModalBody: JSX.Element = (
  <section id='middle'>
    <div className='d-flex justify-content-center'>
      <DoseMeSpinner/>
    </div>
  </section>
)

const errorModalBody = (error: string): JSX.Element => (
  <section id='middle'>
    <div>
      {error}
    </div>
  </section>
)

export const LoadingModal: React.FC<IProps> = (props) => {
  return (
    <Modal
      type='regular'
      show={true}
      body={props.error ? errorModalBody(props.error) : loadingModalBody}
      onHide={props.onHide}
    />
  )
}
